import { z } from 'zod';

import { DependentRelation } from '@/common/graphql';

export const DependentFormData = z.object({
  name: z.string().default(''),
  relation: z.nativeEnum(DependentRelation).nullable().default(null),
  dateOfBirth: z.string().default(''),
});
export type DependentFormDataType = z.infer<typeof DependentFormData>;
